import React from "react";
import "./About.css"

export const About = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>We are a company that does amazing things!</p>
      <div class="wrapper">
        <div class="one">One</div>
        <div class="two">Two</div>
        <div class="three">Three</div>
        <div class="four">Four</div>
        <div class="five">
          <button>Click here for free</button>
        </div>
        <div class="six">Six</div>
      </div>
    </div>
  );
};

